<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '实施文件归档申请', path:'/item'}"></Title>
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">
        <el-divider content-position="left">实施信息</el-divider>
        <el-form-item label="所属项目" prop="projectId">
          <el-select style="width: 50%" v-model="ruleForm.projectId"
                     placeholder="请选择所属项目"
                     filterable>
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.projectName"
                :disabled="item.projectState === 6"
                :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="实施单位" prop="enforceCompany">
          <el-input v-model="ruleForm.enforceCompany"></el-input>
        </el-form-item>

        <el-form-item label="材料名称" prop="enforceName">
          <el-input v-model="ruleForm.enforceName"></el-input>
        </el-form-item>

        <el-form-item label="实施时间" prop="enforceTime">
          <el-date-picker
              v-model="ruleForm.enforceTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择实施时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="实施文件" required>
          <el-upload
              class="upload-demo"
              drag
              action=""
              :multiple=false
              :limit="1"
              :on-exceed="handleExceed"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .ofd, .zip, .rar"
              :on-change="handleFileChange"
              :file-list="fileList"
              :http-request="uploadSectionFile"
              :before-upload="beforeUpload"
              list-type="picture">

            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传word/pdf/ofd/jpg/png/jpeg/zip/rar文件，且不超过20M</div>

          </el-upload>
          <el-alert
            title="pdf文件现已支持在线预览"
            type="info">
          </el-alert>
        </el-form-item>

        <!--        <el-form-item label="是否收到纸质档" prop="hasPaper" required>
                  <el-radio-group v-model="ruleForm.hasPaper">
                    <el-radio label="1">收到</el-radio>
                    <el-radio label="2">未收到</el-radio>
                  </el-radio-group>
                </el-form-item>-->

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                    v-model="ruleForm.remarks"></el-input>
        </el-form-item>

        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>

      </el-form>
    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "../../../util";
import {
  requestAllProject,
  requestContractApply,
  requestEnforceApply,
  requestProjectApply,
  requestSaveSysUser,
  requestApplyDetail
} from "../../../api";

export default {
  components: {Title},
  name: "EnforceApply",
  data() {

    return {
      submitShow: true,

      projectList: [],
      fileList: [],

      applyServiceId: "",
      applyType: "",
      enforceId: null,
      applyId: null,
      reapply: false,

      ruleForm: {
        enforceCompany: "",
        enforceName: "",
        enforceTime: "",
        hasPaper: "1",

        projectId: "",
        remarks: "",

      },
      rules: {
        enforceCompany: [
          {required: true, message: '请输入实施单位', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        projectId: [
          {required: true, message: '请选择所属项目', trigger: 'blur'},
        ],
        enforceName: [
          {required: true, message: '请输入材料名称', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        enforceTime: [
          {required: true, message: '请选择实施时间', trigger: 'blur'},
        ]
      },

    }

  },
  computed: {},
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {


          let formData = new FormData()
          formData.append("enforceCompany", this.ruleForm.enforceCompany)
          formData.append("enforceName", this.ruleForm.enforceName)
          formData.append("enforceTime", this.ruleForm.enforceTime)
          formData.append("hasPaper", this.ruleForm.hasPaper)
          formData.append("projectId", this.ruleForm.projectId)
          formData.append("remarks", this.ruleForm.remarks)

          // 重新申请需要的参数
          if (this.reapply) {
            formData.append("enforceId", this.enforceId)
            formData.append("applyId", this.applyId)
            formData.append("reapply", this.reapply)
          }

          if (this.fileList && this.fileList.length > 0) {
            formData.append("file", this.fileList[0].raw)
            const size = 1024 * 1024 * 20
            if (this.fileList[0].size > size) {
              this.$message.error("文件大小不能超过20MB")
              return
            }
          } else if(!this.reapply) {
            this.$message.error("请上传实施文件")
            return
          }

          this.submitShow = false

          requestEnforceApply(formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('ruleForm')
              this.fileList = []
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.enforceId = detail.enforceId
            this.ruleForm.enforceCompany = detail.enforceCompany
            this.ruleForm.enforceName = detail.enforceName
            this.ruleForm.enforceTime = detail.enforceTime
            this.ruleForm.hasPaper = detail.hasPaper
            this.ruleForm.projectId = detail.projectId
            this.ruleForm.remarks = detail.remarks
            const file = {
              name: detail.fileName,
              url: require('@/assets/word.png')
            }
            this.fileList.push(file)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    handleExceed(files, fileList) {
      this.$message.warning('只能上传1个文件')
    },
    // 上传文件
    uploadSectionFile(file) {

    },
    // 文件修改
    handleFileChange(file, fileList) {
      this.fileChange = true
      file.url = require('@/assets/word.png')
      console.log(file)
      this.fileList.push(file)
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileChange = true
      this.fileList = []
    },
    // 预览
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {

    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

  }
}
</script>

<style scoped>

</style>
